import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { ContentfulEdit } from 'teacher-ui-client/components/contentful/edit'
import { pdfDownloadEvent } from 'teacher-ui-client/modifiers/pdf-download-event'
import { eq } from 'ember-truth-helpers'
import type { Asset } from 'teacher-ui-client/contentful-client/entry-types'

interface Signature {
  Args: {
    asset: Asset
  }
}

export const ResourcesListFile: TOC<Signature> = <template>
  {{#if (eq @asset.fields.file.contentType "application/pdf")}}
    {{! PDF resources can't be downloaded directly as they are on a different origin so need to be opened in a new tab }}
    <a
      href={{@asset.fields.file.url}}
      target="_blank"
      rel="noopener noreferrer"
      {{pdfDownloadEvent category="Teacher Toolkit PDF" label=@asset.fields.title file=@asset.fields.file.fileName}}
    >
      <PhosphorIcon @icon="phosphor-arrow-square-out-bold" class="mr-2 h-5 w-5" />
      {{@asset.fields.title}}
    </a>
  {{else if (eq @asset.fields.file.contentType "video/mp4")}}
    <a href={{@asset.fields.file.url}} target="_blank" rel="noopener noreferrer">
      <PhosphorIcon @icon="phosphor-play-circle-fill" class="mr-2 h-5 w-5" />
      {{@asset.fields.title}}
    </a>
  {{else}}
    {{! Other file types, such as ppt and pptx, can be downloaded directly instead of opening in the browser }}
    <a href={{@asset.fields.file.url}} download>
      <PhosphorIcon @icon="phosphor-download-fill" class="mr-2 h-5 w-5" />
      {{@asset.fields.title}}
    </a>
  {{/if}}
  <ContentfulEdit @assetId={{@asset.sys.id}} class="ml-4" />
</template>
